/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Email_PlaceholderInputs */

const en_login_page_email_placeholder = /** @type {(inputs: Login_Page_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const de_login_page_email_placeholder = /** @type {(inputs: Login_Page_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sie@beispiel.de`)
};

const pt_br2_login_page_email_placeholder = /** @type {(inputs: Login_Page_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voce@exemplo.com`)
};

const tr_login_page_email_placeholder = /** @type {(inputs: Login_Page_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`siz@ornek.com`)
};

const zh_cn2_login_page_email_placeholder = /** @type {(inputs: Login_Page_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nin@example.com`)
};

const zh_hk2_login_page_email_placeholder = /** @type {(inputs: Login_Page_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nei@example.com`)
};

const ko_kr2_login_page_email_placeholder = /** @type {(inputs: Login_Page_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.kr`)
};

const ru_ru2_login_page_email_placeholder = /** @type {(inputs: Login_Page_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vy@example.ru`)
};

const es_419_login_page_email_placeholder = /** @type {(inputs: Login_Page_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@ejemplo.com`)
};

/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Login_Page_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_email_placeholder = /** @type {((inputs?: Login_Page_Email_PlaceholderInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Email_PlaceholderInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_email_placeholder(inputs)
	if (locale === "de") return de_login_page_email_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_email_placeholder(inputs)
	if (locale === "tr") return tr_login_page_email_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_email_placeholder(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_email_placeholder(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_email_placeholder(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_email_placeholder(inputs)
	return es_419_login_page_email_placeholder(inputs)
});